(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'connect-fs-fs-s2-file-fs-file-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'connect-fs-fs-s2-file-fs-file-domain'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'connect-fs-fs-s2-file-fs-file-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'connect-fs-fs-s2-file-fs-file-domain'.");
    }
    root['connect-fs-fs-s2-file-fs-file-domain'] = factory(typeof this['connect-fs-fs-s2-file-fs-file-domain'] === 'undefined' ? {} : this['connect-fs-fs-s2-file-fs-file-domain'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var VOID = kotlin_kotlin.$_$.g;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var objectCreate = kotlin_kotlin.$_$.da;
  var substringBefore = kotlin_kotlin.$_$.ac;
  var removeSuffix = kotlin_kotlin.$_$.sb;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var defineProp = kotlin_kotlin.$_$.b9;
  var classMeta = kotlin_kotlin.$_$.z8;
  //endregion
  //region block: pre-declaration
  setMetadataFor(FileAskQuestionQueryDTO, 'FileAskQuestionQueryDTO', interfaceMeta);
  setMetadataFor(FileAskQuestionResultDTO, 'FileAskQuestionResultDTO', interfaceMeta);
  setMetadataFor(DirectoryPathDTO, 'DirectoryPathDTO', interfaceMeta);
  setMetadataFor(ChatMessageDTO, 'FileAskMessageDTO', interfaceMeta);
  setMetadataFor(ChatMetadataDTO, 'FileAskMetadataDTO', interfaceMeta);
  setMetadataFor(FilePathDTO, 'FilePathDTO', interfaceMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(FilePath, 'FilePath', classMeta, VOID, [FilePathDTO], VOID, VOID, {0: $serializer_getInstance});
  //endregion
  function FileAskQuestionQueryDTO() {
  }
  function FileAskQuestionResultDTO() {
  }
  function DirectoryPathDTO() {
  }
  function ChatMessageDTO() {
  }
  function ChatMetadataDTO() {
  }
  function FilePathDTO() {
  }
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('FilePath', this, 4);
    tmp0_serialDesc.ht('objectType', false);
    tmp0_serialDesc.ht('objectId', false);
    tmp0_serialDesc.ht('directory', false);
    tmp0_serialDesc.ht('name', false);
    this.b28_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.b28_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.b28_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.em(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.em(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return FilePath_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer).c28 = function (encoder, value) {
    var tmp0_desc = this.b28_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.d28_1);
    tmp1_output.jn(tmp0_desc, 1, value.e28_1);
    tmp1_output.jn(tmp0_desc, 2, value.f28_1);
    tmp1_output.jn(tmp0_desc, 3, value.g28_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.c28(encoder, value instanceof FilePath ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function FilePath_init_$Init$(seen1, objectType, objectId, directory, name, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance().b28_1);
    }
    $this.d28_1 = objectType;
    $this.e28_1 = objectId;
    $this.f28_1 = directory;
    $this.g28_1 = name;
    return $this;
  }
  function FilePath_init_$Create$(seen1, objectType, objectId, directory, name, serializationConstructorMarker) {
    return FilePath_init_$Init$(seen1, objectType, objectId, directory, name, serializationConstructorMarker, objectCreate(protoOf(FilePath)));
  }
  function FilePath(objectType, objectId, directory, name) {
    this.d28_1 = objectType;
    this.e28_1 = objectId;
    this.f28_1 = directory;
    this.g28_1 = name;
  }
  protoOf(FilePath).x27 = function () {
    return this.d28_1;
  };
  protoOf(FilePath).y27 = function () {
    return this.e28_1;
  };
  protoOf(FilePath).z27 = function () {
    return this.f28_1;
  };
  protoOf(FilePath).h9 = function () {
    return this.g28_1;
  };
  protoOf(FilePath).toString = function () {
    return removeSuffix(substringBefore(this.d28_1 + '/' + this.e28_1 + '/' + this.f28_1 + '/' + this.g28_1, '//'), '/');
  };
  protoOf(FilePath).hashCode = function () {
    var result = getStringHashCode(this.d28_1);
    result = imul(result, 31) + getStringHashCode(this.e28_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f28_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g28_1) | 0;
    return result;
  };
  protoOf(FilePath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FilePath))
      return false;
    var tmp0_other_with_cast = other instanceof FilePath ? other : THROW_CCE();
    if (!(this.d28_1 === tmp0_other_with_cast.d28_1))
      return false;
    if (!(this.e28_1 === tmp0_other_with_cast.e28_1))
      return false;
    if (!(this.f28_1 === tmp0_other_with_cast.f28_1))
      return false;
    if (!(this.g28_1 === tmp0_other_with_cast.g28_1))
      return false;
    return true;
  };
  //region block: post-declaration
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(FilePath), 'objectType', function () {
    return this.x27();
  });
  defineProp(protoOf(FilePath), 'objectId', function () {
    return this.y27();
  });
  defineProp(protoOf(FilePath), 'directory', function () {
    return this.z27();
  });
  defineProp(protoOf(FilePath), 'name', function () {
    return this.h9();
  });
  //endregion
  //region block: init
  Companion_instance = new Companion();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $io = _.io || (_.io = {});
    var $io$komune = $io.komune || ($io.komune = {});
    var $io$komune$fs = $io$komune.fs || ($io$komune.fs = {});
    var $io$komune$fs$s2 = $io$komune$fs.s2 || ($io$komune$fs.s2 = {});
    var $io$komune$fs$s2$file = $io$komune$fs$s2.file || ($io$komune$fs$s2.file = {});
    var $io$komune$fs$s2$file$domain = $io$komune$fs$s2$file.domain || ($io$komune$fs$s2$file.domain = {});
    var $io$komune$fs$s2$file$domain$features = $io$komune$fs$s2$file$domain.features || ($io$komune$fs$s2$file$domain.features = {});
    var $io$komune$fs$s2$file$domain$features$query = $io$komune$fs$s2$file$domain$features.query || ($io$komune$fs$s2$file$domain$features.query = {});
    var $io = _.io || (_.io = {});
    var $io$komune = $io.komune || ($io.komune = {});
    var $io$komune$fs = $io$komune.fs || ($io$komune.fs = {});
    var $io$komune$fs$s2 = $io$komune$fs.s2 || ($io$komune$fs.s2 = {});
    var $io$komune$fs$s2$file = $io$komune$fs$s2.file || ($io$komune$fs$s2.file = {});
    var $io$komune$fs$s2$file$domain = $io$komune$fs$s2$file.domain || ($io$komune$fs$s2$file.domain = {});
    var $io$komune$fs$s2$file$domain$model = $io$komune$fs$s2$file$domain.model || ($io$komune$fs$s2$file$domain.model = {});
    var $io = _.io || (_.io = {});
    var $io$komune = $io.komune || ($io.komune = {});
    var $io$komune$fs = $io$komune.fs || ($io$komune.fs = {});
    var $io$komune$fs$s2 = $io$komune$fs.s2 || ($io$komune$fs.s2 = {});
    var $io$komune$fs$s2$file = $io$komune$fs$s2.file || ($io$komune$fs$s2.file = {});
    var $io$komune$fs$s2$file$domain = $io$komune$fs$s2$file.domain || ($io$komune$fs$s2$file.domain = {});
    var $io$komune$fs$s2$file$domain$model = $io$komune$fs$s2$file$domain.model || ($io$komune$fs$s2$file$domain.model = {});
    var $io = _.io || (_.io = {});
    var $io$komune = $io.komune || ($io.komune = {});
    var $io$komune$fs = $io$komune.fs || ($io$komune.fs = {});
    var $io$komune$fs$s2 = $io$komune$fs.s2 || ($io$komune$fs.s2 = {});
    var $io$komune$fs$s2$file = $io$komune$fs$s2.file || ($io$komune$fs$s2.file = {});
    var $io$komune$fs$s2$file$domain = $io$komune$fs$s2$file.domain || ($io$komune$fs$s2$file.domain = {});
    var $io$komune$fs$s2$file$domain$model = $io$komune$fs$s2$file$domain.model || ($io$komune$fs$s2$file$domain.model = {});
    var $io = _.io || (_.io = {});
    var $io$komune = $io.komune || ($io.komune = {});
    var $io$komune$fs = $io$komune.fs || ($io$komune.fs = {});
    var $io$komune$fs$s2 = $io$komune$fs.s2 || ($io$komune$fs.s2 = {});
    var $io$komune$fs$s2$file = $io$komune$fs$s2.file || ($io$komune$fs$s2.file = {});
    var $io$komune$fs$s2$file$domain = $io$komune$fs$s2$file.domain || ($io$komune$fs$s2$file.domain = {});
    var $io$komune$fs$s2$file$domain$model = $io$komune$fs$s2$file$domain.model || ($io$komune$fs$s2$file$domain.model = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = FilePath;
  //endregion
  return _;
}));

//# sourceMappingURL=connect-fs-fs-s2-file-fs-file-domain.js.map
